import { type ADFDocument, type ADFMarkType } from '@canvas/adf-types';

export function plainTextToAdf(text: string, ...marks: ADFMarkType[]): ADFDocument {
  return {
    version: 1,
    type: 'doc',
    content: [
      {
        type: 'paragraph',
        content: [
          {
            type: 'text',
            text,
            marks: marks.map((mark) => ({
              attrs: {},
              type: mark,
            })),
          },
        ],
      },
    ],
  };
}
